module.exports = function getResource(label, vars = []) {
    const resources = {
        close: 'Close',
        bopisItemAddedModalTitle: 'Item added to basket',
        shippingItemAddedModalTitle: 'Added to Get It Shipped basket',
        viewBasketAndReserve: 'View Basket & Reserve',
        viewBasketAndCheckout: 'View Basket & Checkout',
        ropisItemAdded: 'Item has been added to basket',
        pickUpAt: 'for pickup at ',
        testCreditCardMessageBody: 'Earn 4% back in rewards when you use your Sephora Credit Card at Sephora.',
        testCreditCardMessageTitle: 'Don’t Forget to Use Your Sephora Credit Card',
        testCreditCardSeeDetails: 'See Details',
        testCardDiscount: `Save ${vars[0]} off your Sephora order when you open and use your Sephora Credit Card.`,
        testCardDiscountTitle: 'Open a Sephora Credit Card Today',
        sameDayDeliveryConfirmation: `Item has been added to basket for ${vars[0]} to `,
        item: 'Item',
        items: 'Items',
        autoReplenishModalTitle: 'Item added to Auto-Replenish',
        autoReplenishSuccessMessage: 'Item has been added and will be delivered every',
        autoReplenish: 'Auto-Replenish',
        sameDayDelivery: 'Same-Day Delivery',
        standard: 'Standard',
        seeAll: 'See all',
        getBackToYourBasket: 'Get Back to Your Basket',
        viewBasket: 'View Basket',
        viewBasketCheckout: 'View Basket & Checkout'
    };

    return resources[label];
};
